import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("menu.analytic.my_resources"))),
      ]),
      _c(
        VCard,
        { staticClass: "mt-2" },
        [
          _c(
            VCardActions,
            { staticClass: "pa-3 pb-1" },
            [
              _c(VSpacer),
              _c(
                VTooltip,
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function (ref) {
                        var on = ref.on
                        var attrs = ref.attrs
                        return [
                          _c(
                            VBtn,
                            _vm._g(
                              _vm._b(
                                {
                                  staticClass: "mr-2",
                                  attrs: {
                                    outlined: "",
                                    fab: "",
                                    small: "",
                                    color: "primary",
                                  },
                                  on: { click: _vm.getResources },
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [_c(VIcon, [_vm._v("mdi-refresh")])],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("btns.refresh")))])]
              ),
              _c(
                VTooltip,
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function (ref) {
                        var on = ref.on
                        var attrs = ref.attrs
                        return [
                          _c(
                            VBtn,
                            _vm._g(
                              _vm._b(
                                {
                                  attrs: { outlined: "", color: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$refs[
                                        _vm.MODAL_REQUEST_RESOURCE
                                      ].onOpen()
                                    },
                                  },
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [_vm._v(_vm._s(_vm.$t("btns.request")))]
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("frases.request_work_env"))),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(VDataTable, {
            key: _vm.key_table,
            staticClass: "text-center table-inca",
            attrs: {
              headers: _vm.headers,
              items: _vm.items,
              responsive: "",
              "hide-default-footer": "",
            },
            scopedSlots: _vm._u([
              {
                key: "item.notebook_url",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.instanceUrl(item),
                          target: "_blank",
                        },
                      },
                      [_vm._v(_vm._s(item.notebook_url))]
                    ),
                  ]
                },
              },
              {
                key: "item.status",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c(
                      VChip,
                      {
                        attrs: {
                          color: _vm.statusColor(item),
                          "text-color": "white",
                          dense: "",
                          small: "",
                        },
                      },
                      [_vm._v(_vm._s(item.status))]
                    ),
                  ]
                },
              },
              {
                key: "item.actions",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    item.status === "ACTIVE"
                      ? _c(
                          VTooltip,
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        VBtn,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                icon: "",
                                                color: "blue",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toggleInstance(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(VIcon, [
                                            _vm._v("mdi-toggle-switch-off"),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("botones.boton_turn_off_work_env")
                                )
                              ),
                            ]),
                          ]
                        )
                      : item.status === "STOPPED"
                      ? _c(
                          VTooltip,
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        VBtn,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                icon: "",
                                                color: "blue",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toggleInstance(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(VIcon, [
                                            _vm._v("mdi-toggle-switch"),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("botones.boton_turn_on_work_env"))
                              ),
                            ]),
                          ]
                        )
                      : _c(VProgressCircular, {
                          attrs: { indeterminate: "", color: "primary" },
                        }),
                    item.status === "STOPPED"
                      ? _c(
                          VTooltip,
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        VBtn,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "btn-icon-inca",
                                              attrs: { icon: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onOpenRequestUpdate(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [_c(VIcon, [_vm._v("icon-edit")])],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("botones.boton_update"))),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    false
                      ? _c(
                          VTooltip,
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        VBtn,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "btn-icon-inca",
                                              attrs: { icon: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.viewMonitoring(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [_c(VIcon, [_vm._v("icon-view")])],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("botones.boton_monitoring"))
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("dialogs-component", {
        ref: _vm.MODAL_REQUEST_UPDATE,
        attrs: { title: "Request Resource", "show-buttons": true },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("form-request-update-component", {
                  ref: "resourceUpdateRef",
                  attrs: {
                    config: _vm.config,
                    "instance-to-update": _vm.itemToUpdate,
                  },
                  on: {
                    cancel: function ($event) {
                      return _vm.$refs[_vm.MODAL_REQUEST_UPDATE].onClose()
                    },
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: { color: "error" },
                    on: {
                      click: function ($event) {
                        return _vm.$refs.resourceUpdateRef.onCancel($event)
                      },
                    },
                  },
                  [
                    _c(VIcon, { attrs: { small: "" } }, [
                      _vm._v("icon-remove"),
                    ]),
                    _vm._v("Cancel"),
                  ],
                  1
                ),
                _c(
                  VBtn,
                  {
                    attrs: { color: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.$refs.resourceUpdateRef.onSubmit($event)
                      },
                    },
                  },
                  [
                    _c(VIcon, { attrs: { small: "" } }, [
                      _vm._v("icon-send"),
                    ]),
                    _vm._v(_vm._s(_vm.$t("btns.request"))),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialogs-component", {
        ref: _vm.MODAL_REQUEST_RESOURCE,
        attrs: { title: "Request Resource", "show-buttons": true, width: 900 },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("form-resource-request-component", {
                  ref: "resourceRequestRef",
                  attrs: { config: _vm.config },
                  on: {
                    cancel: function ($event) {
                      return _vm.$refs[_vm.MODAL_REQUEST_RESOURCE].onClose()
                    },
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: { color: "error" },
                    on: {
                      click: function ($event) {
                        return _vm.$refs.resourceRequestRef.onCancel($event)
                      },
                    },
                  },
                  [
                    _c(VIcon, { attrs: { small: "" } }, [
                      _vm._v("icon-remove"),
                    ]),
                    _vm._v("CANCEL"),
                  ],
                  1
                ),
                _c(
                  VBtn,
                  {
                    attrs: { color: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.$refs.resourceRequestRef.onSubmit($event)
                      },
                    },
                  },
                  [
                    _c(VIcon, { attrs: { small: "" } }, [
                      _vm._v("icon-send"),
                    ]),
                    _vm._v(_vm._s(_vm.$t("btns.request"))),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialogs-component", {
        ref: _vm.MODAL_MONITORING_RESOURCE,
        attrs: { title: "Resource Monitoring", width: 800 },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _vm.loaded
                  ? _c("line-chart", { attrs: { chartdata: _vm.cpuData } })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }